import { cn } from '@tripleten/cn';

export const cnSocialButtons = cn('social-buttons');
